/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, FontFamily, FontSize,
  Components,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.DOR_MEASUREMENTS;

export const CircularGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 200px;
`;

export const CircularGraphLabel = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED10)};
  text-align: center;
`;

export const CircularGraphInnerTextOverride = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED40, undefined, undefined)};
`;

export const InnerTextSplitLarge = styled.div`
  color: ${({ $colorOverride, $colorProfile }) => (($colorOverride) || themeUtil(Prop.CONTENT, CPNT, $colorProfile))};
`;

export const InnerTextSplitSmall = styled.div`
  margin-top: 5px;
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG30, undefined, undefined)};
`;

export const TextMeasurementItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
  // currently unused, keeping because I have a feeling it might change once
  // in use
  &.text-hours {
    height: 100%;
    justify-content: space-between;
  }

  &.add-gap {
    gap: 20px;

    ${Breakpoints.mobile(css`
      gap: 7px;
    `)}
  }
`;

export const TextMeasurementLabel = styled.div`
  margin-bottom: 15px;
  color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};

  ${({ $large }) => (($large)
    ? getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED50, undefined, undefined)
    : getFontStyles(FontFamily.BASE_FONT, FontSize.REG40, undefined, undefined))};

  ${Breakpoints.mobile(css`
    margin-bottom: 10px;
  `)}

  &.text-hours {
    margin-bottom: 0px;
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED50, undefined, undefined)};


    ${Breakpoints.mobile(css`
      ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG20, undefined, undefined)}
    `)}
  }
`;

export const TextMeasurementIcon = styled(Icon)`
  width: 35px;
  height: 35px;

  ${Breakpoints.mobile(css`
    width: 28px;
    height: 28px;
  `)}

  &.text-hours {
    width: 35px;
    height: 35px;
    min-height: 35px;
    min-width: 35px;

    ${Breakpoints.mobile(css`
      width: 20px;
      height: 20px;

      min-height: 20px;
      min-width: 20px;
    `)}
  }

  svg {
    fill: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
  }
`;

export const TextIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;

  ${Breakpoints.mobile(css`
    gap: 5px;
  `)}
`;

export const StatusDot = styled.div`
  height: 50px;
  width: 50px;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  background-color: ${({ $colorOverride, $colorProfile }) => (($colorOverride) || themeUtil(Prop.CONTENT, CPNT, $colorProfile))};

  ${Breakpoints.mobile(css`
    height: 22px;
    width: 22px;
    min-width: 22px;
    min-height: 22px;
  `)}
`;

const sharedTextStyles = css`
  ${({ $small, $smaller }) => getFontStyles(FontFamily.PRIMARY_FONT, ($smaller) ? '35px' : ($small) ? '45px' : '84px', undefined, undefined)};
  line-height: 1;
  color: ${({ $colorOverride, $colorProfile }) => (($colorOverride) || themeUtil(Prop.CONTENT, CPNT, $colorProfile))};

  ${Breakpoints.mobile(css`
    ${({ $small, $smaller }) => getFontStyles(FontFamily.PRIMARY_FONT, ($smaller) ? '20px' : ($small) ? '30px' : FontSize.LRG30, undefined, undefined)};
  `)}
`;

export const TextMeasurementContent = styled.div`
  ${sharedTextStyles}

  &.text-hours {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;

    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED40, undefined, undefined)}

    ${Breakpoints.mobile(css`
      gap: 5px;
      ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG10, undefined, undefined)}
    `)}
    
  }
`;

export const ItemText = styled.div``;

export const ItemValue = styled.p`
  ${sharedTextStyles}
`;

export const ItemUnit = styled.span`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.MED10, undefined, undefined)};
`;

export const TextMeasurementSplit = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TextMeasurementSplitLarge = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, '84px', undefined, undefined)};
`;

export const TextMeasurementSplitSmall = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, '28px', undefined, undefined)};
`;

export const AdditionalInfo = styled.div`
  margin-top: 10px;
  color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
  ${() => getFontStyles(FontFamily.BASE_FONT, '28px', undefined, undefined)};
`;
